import { FC, Suspense } from "react";
import { useLocation } from "react-router-dom";

import { FunnelImportContainer } from "~/src/components/features/settings/FunnelImport";
import { FunnelImportRowValues } from "~/src/components/features/settings/FunnelImport/validationSchema";
import { useFunnelImportPageParams } from "~/src/routes/hooks";

import { FunnelImportPage } from "./presentations";

type FunnelImportLocationState = {
  funnels?: FunnelImportRowValues[];
};

export const FunnelImportPageContainer: FC = () => {
  const { siteSlug } = useFunnelImportPageParams();
  const location = useLocation();
  const state = location.state as FunnelImportLocationState | null | undefined;
  const initialFunnels = state?.funnels;

  return (
    <FunnelImportPage siteSlug={siteSlug}>
      <Suspense fallback={null}>
        <FunnelImportContainer
          siteSlug={siteSlug}
          initialFunnels={initialFunnels}
        />
      </Suspense>
    </FunnelImportPage>
  );
};
